import styled from "styled-components";

export const CalendarDayItemStyled = styled.div`
  position: relative;
  box-sizing: border-box;
  border-right: 1px solid #e5e5e5;
  border-bottom: 1px solid #e5e5e5;
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: center;
  height: 60px;
  background-color: ${({ isHoliday, theme }) =>
    isHoliday ? theme.COLORS.GRAY_2 : theme.COLORS.WHITE_1};
  .status-indicator {
    position: absolute;
    left: 0;
    top: 0;
    bottom: 0;
    width: 8px;
    background-color: ${({ indicatorColor }) =>
      indicatorColor ? indicatorColor : "transparent"};
  }
  .cld_row {
    padding: 4px 8px 4px 16px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    gap: 2px;
    flex: 1;
    min-width: 0;
    line-height: 16px;
    .cld_phone {
      color: ${({ theme }) => theme.COLORS.BLACK_1};
      font-size: ${({ theme }) => theme.FONT.SIZE.S14};
      font-family: ${({ theme }) => theme.FONT.STYLE.KANIT_REGULAR};
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }
    .cld_product {
      color: ${({ theme }) => theme.COLORS.BLACK_1};
      font-size: ${({ theme }) => theme.FONT.SIZE.S12};
      font-family: ${({ theme }) => theme.FONT.STYLE.KANIT_LIGHT};
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }
  }

  .theme_standard {
  }
`;
